import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=720c65b4&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=ts"
export * from "./LocationCard.vue?vue&type=script&lang=ts"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=720c65b4&prod&scoped=true&lang=sass"
import style1 from "./LocationCard.vue?vue&type=style&index=1&id=720c65b4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c65b4",
  null
  
)

export default component.exports